(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('.tnws-social__tab');
    var panels = root.querySelectorAll('.tnws-social__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filter = tab.dataset.filter;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = filter !== 'all' && p.dataset.platform !== filter;
        });
      });
    });
  }

  function loadTikTok(wrap) {
    if (wrap.dataset.loaded) return;
    wrap.dataset.loaded = 'true';

    var handle = wrap.dataset.handle;
    var embed = wrap.querySelector('[data-tiktok-embed]');
    var fallback = wrap.querySelector('[data-tiktok-fallback]');

    embed.innerHTML =
      '<blockquote class="tiktok-embed" cite="https://www.tiktok.com/@' + handle + '" data-unique-id="' + handle +
      '" data-embed-type="creator" style="max-width:780px;min-width:288px;"><section>' +
      '<a target="_blank" rel="noopener" href="https://www.tiktok.com/@' + handle + '?refer=creator_embed">@' + handle +
      '</a></section></blockquote>';
    embed.hidden = false;
    embed.classList.add('is-loading');

    var settled = false;
    var observer = new MutationObserver(function () {
      var frame = embed.querySelector('iframe');
      if (!frame || settled) return;
      settled = true;
      observer.disconnect();
      frame.addEventListener('load', function () {
        embed.classList.remove('is-loading');
        fallback.hidden = true;
      });
    });
    observer.observe(embed, { childList: true, subtree: true });

    setTimeout(function () {
      if (settled) return;
      observer.disconnect();
      embed.hidden = true;
      embed.innerHTML = '';
    }, 10000);

    var script = document.createElement('script');
    script.src = 'https://www.tiktok.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
  }

  function initTikTok(root) {
    var wrap = root.querySelector('[data-tiktok-live]');
    if (!wrap) return;
    if (!('IntersectionObserver' in window)) return loadTikTok(wrap);
    var io = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          loadTikTok(wrap);
        }
      },
      { rootMargin: '300px 0px' }
    );
    io.observe(wrap);
  }

  function init() {
    document.querySelectorAll('.tnws-social').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      initTabs(root);
      initTikTok(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
